/* POGO core: logging helper only (see AGENTS.md). */
(function () {
  'use strict';
  var debug = false;
  try {
    debug = new URLSearchParams(window.location.search).get('pogo_debug') === '1';
  } catch (e) {
    debug = false;
  }
  var levels = { ERROR: 'error', WARN: 'warn', INFO: 'info', DEBUG: 'debug' };
  window.pogoLog = function (level, msg) {
    var key = String(level || '').toUpperCase();
    var method = levels[key];
    if (!method) {
      key = 'WARN';
      method = 'warn';
      msg = 'pogoLog: unknown level "' + level + '" for message: ' + msg;
    }
    if ((key === 'INFO' || key === 'DEBUG') && !debug) return;
    try {
      console[method]('[POGO] ' + key + ': ' + msg);
    } catch (e) {
      /* console unavailable: logging must never break the page */
    }
  };
})();
